import { Tooltip } from '@datacamp/waffles/tooltip';
import { css } from '@emotion/react';
import React, { cloneElement, useState } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const ScoreButton = _ref => {
  let {
    children,
    currentScore,
    dataTrackIdExerciseTypePrefix,
    defaultColor,
    hoveredColor,
    isValidator = false,
    score,
    scorePrediction,
    setFeedbackDialogOpen,
    setScore,
    tooltipContent
  } = _ref;
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const validatorPurpleColor = 'rgba(176, 142, 255, 1)';
  const validatorHoverColor = 'rgba(150, 100, 255, 1)';
  const validatorGreyColor = 'rgba(200, 200, 200, 0.8)';
  const getButtonColor = () => {
    if (!isValidator) {
      return isHovered ? hoveredColor : defaultColor;
    }
    if (currentScore !== undefined) {
      if (score === currentScore) {
        return validatorPurpleColor;
      }
      return validatorGreyColor;
    }

    // When no score has been selected yet
    return isHovered ? validatorHoverColor : validatorPurpleColor;
  };
  const svgElement = cloneElement(children, {
    stroke: getButtonColor()
  });
  const buttonStyle = /*#__PURE__*/css({
    backgroundColor: isValidator ? 'transparent' : undefined,
    border: 'none',
    cursor: 'pointer'
  }, "production" === "production" ? "" : ";label:buttonStyle;", "production" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  const isNegativeScore = score === 0;
  const onClickHandler = () => {
    if (scorePrediction === undefined) {
      return;
    }
    if (!isNegativeScore) {
      scorePrediction({
        score
      });
      setScore(score);
      setIsHovered(false);
    }
    if (isNegativeScore) {
      setFeedbackDialogOpen(true);
    }
  };
  const feedbackButtonHeapTrackId = () => {
    if (isNegativeScore) {
      return "".concat(dataTrackIdExerciseTypePrefix, "-feedback-negative-rate-button");
    }
    return "".concat(dataTrackIdExerciseTypePrefix, "-feedback-positive-rate-button");
  };
  return ___EmotionJSX(Tooltip, {
    content: tooltipContent,
    placement: "bottomLeft"
  }, ___EmotionJSX("button", {
    css: buttonStyle,
    "data-trackid": feedbackButtonHeapTrackId(),
    disabled: currentScore !== undefined,
    onClick: () => onClickHandler(),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, svgElement));
};